import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import i18n from "../../../../utils/i18n";
import classes from "./generalError.module.scss";

const SUPPORT_CONTACT = {
  name: "Bodnár Nikoletta Leila",
  role: i18n.t("searchflow.errorrole"),
  phoneDisplay: "+36 20 238 3689",
  phoneHref: "+36202383689",
  email: "nina@bookkeepie.com",
  calComUrl:
    "https://cal.com/team/bookkeepie-magyarorszag/bookkeepie-ugyintezes-idopontfoglalas-delelott",
};

const GeneralError = () => (
  <div className={classes.root}>
    <div className={classes.scrollArea}>
      <div className={classes.content}>
        <div className={classes.mainColumn}>
          <header className={classes.header}>
            <div className={classes.warningIcon} aria-hidden="true">
              ⚠️
            </div>
            <h1 className={classes.title}>
              {i18n.t("searchflow.errortitle")}
            </h1>
            <p className={classes.subtitle}>
              {i18n.t("searchflow.errorsubtitle")}
            </p>
          </header>

          <div className={classes.rightColumn}>
            <div className={classes.body}>
              <div className={classes.contactCard}>
                <p className={classes.contactName}>{SUPPORT_CONTACT.name}</p>
                <p className={classes.contactRole}>{SUPPORT_CONTACT.role}</p>

                <div className={classes.contactLinks}>
                  <a
                    className={classes.contactChip}
                    href={`mailto:${SUPPORT_CONTACT.email}`}
                  >
                    <EmailOutlinedIcon
                      className={classes.contactChipIcon}
                      aria-hidden="true"
                    />
                    <span>{SUPPORT_CONTACT.email}</span>
                  </a>
                  <a
                    className={classes.contactChip}
                    href={`tel:${SUPPORT_CONTACT.phoneHref}`}
                  >
                    <PhoneOutlinedIcon
                      className={classes.contactChipIcon}
                      aria-hidden="true"
                    />
                    <span>{SUPPORT_CONTACT.phoneDisplay}</span>
                  </a>
                </div>

                <a
                  className={classes.bookButton}
                  href={SUPPORT_CONTACT.calComUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {i18n.t("searchflow.bookbutton")}
                </a>
              </div>

              <p className={classes.hours}>
                {i18n.t("searchflow.errorhours")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default GeneralError;
